import React, { useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { debounce } from "../../../utils/helpers/debounce";
import classes from "./sparePartOptions.module.css";

export const SparePartOptions = ({ sparePartsData, spares = [], onChange }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Debounce handler
  const debouncedSearchHandler = useMemo(
    () =>
      debounce((value) => {
        setDebouncedSearch(value);
      }, 300),
    []
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSearchHandler(value);
  };

  // Filter spare parts
  const filteredSpareParts = useMemo(() => {
    const search = debouncedSearch.trim().toLowerCase();
    if (!search) return sparePartsData.filter_options;

    return sparePartsData.filter_options.filter((part) =>
      part.label.toLowerCase().includes(search)
    );
  }, [debouncedSearch, sparePartsData.filter_options]);

  const toggleSpare = (id) => {
    const isSelected = spares.includes(id);

    const next = isSelected ? spares.filter((s) => s !== id) : [...spares, id];

    onChange?.({ spare: next });
  };

  return (
    <div className={classes.box}>
      <div className={classes.box__head}>
        <label htmlFor="spare-search" className={classes.box__head__label}>
          <input
            type="search"
            placeholder="Search spare parts..."
            id="spare-search"
            className={classes.box__head__input}
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </label>
      </div>

      <motion.div
        className={classes.box__content}
        layout
        transition={{ duration: 0.35, ease: "easeInOut" }}
      >
        <AnimatePresence>
          {filteredSpareParts.length === 0 ? (
            <div className={classes.noResultsWrapper}>
              <p className={classes.noResultsText}>No spare parts found.</p>
            </div>
          ) : (
            filteredSpareParts.map((part) => (
              <label
                key={part.id}
                htmlFor={`spare-${part.id}`}
                className={classes.box__content__spare__label}
              >
                <input
                  type="checkbox"
                  id={`spare-${part.id}`}
                  className={classes.box__content__spare__input}
                  checked={spares.includes(part.id)}
                  onChange={() => toggleSpare(part.id)}
                />

                <span className={classes.box__content__spare__checkbox}></span>

                <span className={classes.box__content__spare__title}>
                  {part.label}
                </span>
              </label>
            ))
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};
